export function getBreadcrumbFromRouteQuery(routeQuery) {
  if (routeQuery && routeQuery.route && "breadcrumb" in routeQuery.route) {
    return routeQuery.route.breadcrumb || [];
  }
  return [];
}
